export default {
  title: '聊天机器人',
  tab: '聊天机器人'
}
